import React from 'react'

const Feedback = () => {
    return (
        <div className='bg-[#00101D]'>
            <div className="max-w-3xl mx-auto px-4 lg:px-0 py-32 text-center">
                <div className="text-yellow-400 text-4xl mb-4">★★★★★</div>
                <p className="text-sm md:text-2xl text-white mb-6 text-center md:text-start">
                    Everest Apps helped me every step of the way. I’ve worked with multiple development companies but I found the right one here. Transparency, Communication and High Quality”
                </p>
                <div className="flex items-center justify-center flex-col md:flex-row gap-4">
                    <img
                        src="/assets/avatar.png"
                        alt="Bryce Poisel"
                        className="w-12 h-12 rounded-full object-cover"
                />
                    <div className="text-lg text-center md:text-left">
                        <p className="text-primary font-semibold">Bryce Poisel - CEO</p>
                        <p className="text-gray-500">Talent Lockr, www.talentlockr.com</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feedback